import { AfterContentInit, AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AudioServiceService } from '../audio-service.service';
import { GamePlayService } from '../game-play/gamePlayService.service';
import { LeaderBoardService } from '../leader-board/leaderBoardService.service';
import { routeService } from '../route-service.service';
import scene1 from '../../assets/anim/Scene1.json';
import bg from '../../assets/anim/BG.json';
import birds from '../../assets/anim/Birds.json';
import logo1 from '../../assets/anim/Logo1.json';
import sun from '../../assets/anim/Sun.json';

@Component({
  selector: 'app-choose-game',
  templateUrl: './choose-game.component.html',
  styleUrls: ['./choose-game.component.scss']
})
export class ChooseGameComponent implements OnInit, AfterContentInit {
  constructor(private routeService: routeService, private leaderBoardService: LeaderBoardService, private router: Router, private gamePlayService: GamePlayService, private audioService: AudioServiceService) { }

  champs = [];
  val = '';

  c5 = {
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: scene1
  };

  ngAfterContentInit() {
    setTimeout(() => {
      let logo_match_anim: any = document.getElementById('logo-match-anim');
      logo_match_anim.seek(100);
      let logo_trivia_anim: any = document.getElementById('logo-trivia-anim');
      logo_trivia_anim.seek(150);
    }, 10);

  }

  ngOnInit(): void {
    // setTimeout(() => {
    //   setInterval(() => {
    //     logo_match_anim.seek(this.gg);
    //     // this.gg++;
    //     this.gg = this.gg > 100 ? 0 : this.gg+1;
    //   }, 10);
    // }, 2000);


    // let logo_match_anim: any = document.getElementById('logo-match-anim');
    // logo_match_anim.addEventListener('freeze', () => {
    //   console.log("111111111111111111111");

    //   logo_match_anim.seek(100);
    // });
    // let logo_trivia_anim: any = document.getElementById('logo-trivia-anim');
    // logo_trivia_anim.addEventListener('freeze', () => {
    //   logo_trivia_anim.seek(150);
    // });

    // console.log(scene1);
    // let rat = 1080/1815;
    // let x = window.outerHeight * rat;
    // console.log(window.innerWidth);
    // console.log(window.outerHeight);
    // console.log(Math.floor(x));


    this.champs = this.leaderBoardService.getChampions();
    let url = this.router.url;
    console.log(url);

    // if (url == '/match-game/mitanim' || url == '/match-game/nosaim') {
    //   this.audioService.playAudio('matchGame', true);
    // } else if (url == 'trivia-game/mitanim' || url == 'trivia-game/nosaim') {
    //   this.audioService.playAudio('triviaGame', true);
    // } else if (url == '/choose') {
    //   console.log("playchoose");

    //   this.audioService.playAudio('chooseGame', true);

    //   setTimeout(() => {
    //     this.aaa = true;
    //   }, 5000);
    // }

    // this.audioService.playAudio('chooseGame');
    // this.gamePlayService.chooseGame.muted = false;
    // this.gamePlayService.chooseGame.play();

    // this.playAudio()
  }
  // ngAfterViewInit() {
  //   let logo_match_anim: any = document.getElementById('logo-match-anim');
  //   logo_match_anim.seek(100);
  // }
  // playAudio(){
  //   let audio = new Audio();
  //   audio.src = "../../assets/sound/main_track.mp3";
  //   audio.autoplay = true;
  //   audio.muted = false;
  //   audio.load();
  //   // audio.play();
  // }

  anim;
  aaa = false;

  changeGame(game, ev) {
    // let birds: any = document.elementFromPoint(ev.pageX, ev.pageY);
    let birds: any = document.getElementById('birds-anim');
    // birds.style.zIndex = '0';

    let kind = game.split('_')[0];
    this.gamePlayService.game = {
      name: game,
      kind: kind
    }
    // if (kind == 'match') {
    //   this.audioService.playAudio('matchGame', true);
    // } else if (kind == 'trivia') {
    //   this.audioService.playAudio('triviaGame', true);
    // }
    birds.style.zIndex = '9';
  }

  zBirds(ev) {
    let birds: any = document.getElementById(ev.target.id);
    birds.style.zIndex = '0';
    var container_el: any = document.elementFromPoint(ev.pageX, ev.pageY);
    container_el.click();
  }

  chooseSection(ev) {
    let opacityMatch = document.getElementById('opacity-match');
    let opacityTrivia = document.getElementById('opacity-trivia');
    let match = document.getElementById('play-container-match');
    let trivia = document.getElementById('play-container-trivia');
    var container_el: any = ev.target;
    let birds: any = document.getElementById('birds-anim');
    // if (container_el.id == 'birds-anim') {
      // birds = container_el;
      // container_el.style.zIndex = '0';
      // container_el = document.elementFromPoint(ev.pageX, ev.pageY);
      console.log(container_el.id);
      console.log(container_el);
      
    // }
    // console.log(container_el.id);
    // console.log(opacityMatch);
    // console.log(opacityTrivia);
    // console.log(match);
    // console.log(trivia);
    // if (container_el.id == 'match-logo' || container_el.id == 'opacity-match') {
    if (container_el.id == 'logo-match-anim' || container_el.id == 'opacity-match') {
      let logo_match_anim: any = document.getElementById('logo-match-anim');
      logo_match_anim.seek(0);
      logo_match_anim.play();
      opacityMatch.classList.add('opacity-in');
      opacityTrivia.classList.remove('opacity-in');
      match.classList.add('play-show');
      trivia.classList.remove('play-show');
      birds.style.zIndex = '9';
      // } else if (container_el.id == 'trivia-logo' || container_el.id == 'opacity-trivia') {
    } else if (container_el.id == 'logo-trivia-anim' || container_el.id == 'opacity-trivia') {
      let logo_trivia_anim: any = document.getElementById('logo-trivia-anim');
      logo_trivia_anim.seek(0);
      logo_trivia_anim.play();
      opacityTrivia.classList.add('opacity-in');
      opacityMatch.classList.remove('opacity-in');
      trivia.classList.add('play-show');
      match.classList.remove('play-show');
      birds.style.zIndex = '9';
    } else {
      opacityMatch.classList.remove('opacity-in');
      opacityTrivia.classList.remove('opacity-in');
      trivia.classList.remove('play-show');
      match.classList.remove('play-show');
      birds.style.zIndex = '9';
    }
    // let opacityMatch = document.getElementById('opacity-match');
    // let opacityTrivia = document.getElementById('opacity-trivia');
    // if (game == 'trivia') {
    //   opacityTrivia.classList.add('opacity-in');
    //   opacityMatch.classList.remove('opacity-in');
    //   trivia.classList.add('play-show');
    //   match.classList.remove('play-show');
    // } else if (game == 'match') {
    //   opacityMatch.classList.add('opacity-in');
    //   opacityTrivia.classList.remove('opacity-in');
    //   match.classList.add('play-show');
    //   trivia.classList.remove('play-show');
    // }

  }

  // ngOnDestroy() {
  //   this.gamePlayService.chooseGame.pause();
  // }
}
